import type { OptionT } from "@/components/form/Select";
import type {
	ShockwaveContentT,
	ShockwaveLocationT,
} from "@/types/database/pain";
import arraySort from "array-sort";
import type { SurgeryOptionT } from "../../../types/database/events";

type ShockwaveInfo = ShockwaveContentT | ShockwaveLocationT;

export const removeDuplicateOptions = (
	options: OptionT[],
	isNumeric?: boolean,
) => {
	const uniOpts = options?.filter(
		(v, i, a) =>
			a.findIndex((t) => t.label === v.label && t.value === v.value) === i,
	);

	if (isNumeric) {
		const numeric = uniOpts?.sort((a, b) => Number(a.value) - Number(b.value));
		return numeric;
	}
	return arraySort(uniOpts, "value");
};

export const createUniqueShockwaveOptions = (
	shockwaveLocations: ShockwaveInfo[],
	key: string,
	isNumeric?: boolean,
): OptionT[] => {
	const opts = shockwaveLocations?.map((location) => ({
		label: String(location[key]),
		value: String(location[key]),
	}));

	return removeDuplicateOptions(opts, isNumeric);
};

export const toFilteredUniqueShockwaveOptions = (
	shockwaveLocations: ShockwaveInfo[],
	key: string,
	filterKey: string,
	filterValue: string,
	isNumeric?: boolean,
): OptionT[] => {
	const filteredShockwaveLocations = shockwaveLocations?.filter(
		(loc) => String(loc[filterKey]) === String(filterValue),
	);
	const filteredUnique = createUniqueShockwaveOptions(
		filteredShockwaveLocations,
		key,
		isNumeric,
	);
	// Return unfiltered if the function doesn't work

	return filteredUnique?.length > 0
		? filteredUnique
		: createUniqueShockwaveOptions(shockwaveLocations, key);
};
export const filterSurgeryOptions = (
	surgeryOptions: SurgeryOptionT[],
	filterKey: string,
	filterValue: string,
): SurgeryOptionT[] => {
	const surOpts = filterValue
		? surgeryOptions?.filter(
				(loc) => String(loc[filterKey]) === String(filterValue),
			)
		: surgeryOptions;
	const opts = surOpts?.map((so) => ({
		value: so.surgery_option_id,
		label: so.surgery_name,
	}));
	return removeDuplicateOptions(opts);
};